import { enrollFactor } from '@wix/ambassador-identity-factors-v1-identity-factor/http';
import {
  FactorType,
  EnrollFactorResponse,
} from '@wix/ambassador-identity-factors-v1-identity-factor/types';
import type { RequestOptionsFactory } from '@wix/http-client';
import { httpClient } from './httpClient';
import { serializeRegistrationCredential } from '../utils/credentialSerializer';

export class WebAuthnApi {
  public async enrollWebAuthn(
    credential?: Credential,
    accessToken?: string,
  ): Promise<EnrollFactorResponse> {
    const serializedCredential = credential
      ? serializeRegistrationCredential(credential as PublicKeyCredential)
      : undefined;

    const factory = enrollFactor({
      factorType: FactorType.WEBAUTHN,
      webauthnData: { credential: serializedCredential },
    });

    // In the step-up flow we authorize with the access token minted from the
    // pre-authorized OAuth code instead of the password verification step.
    const requestFactory: RequestOptionsFactory<EnrollFactorResponse> =
      accessToken
        ? (context) => {
            const options = factory(context);
            return {
              ...options,
              headers: {
                ...options.headers,
                Authorization: `Bearer ${accessToken}`,
              },
            };
          }
        : factory;

    return httpClient.request(requestFactory).then((response) => response.data);
  }
}
